module.exports = __webpack_public_path__ + "img/banner-principal-decorativo-1.9839f862.png";